import { Navigate, useLocation } from 'react-router-dom';
import {
    PROPERTY_LISTING_PATH,
    buildListPropertyRedirectSearch,
} from '@/lib/listingGeoRedirect';

/** Redirect legacy `/list/geo` to the GenUI listing shell, preserving city/country params. */
export function GeoListingRedirect() {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const nextSearch = buildListPropertyRedirectSearch(params);
    return <Navigate to={`${PROPERTY_LISTING_PATH}${nextSearch}`} replace />;
}
